import { useState, useEffect } from 'react';

const WindowWidthState = () => {
  // Trigger a re-render when window size changes
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Define the event listener function
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // The empty dependency array ensures this useEffect runs once, similar to componentDidMount

  return windowWidth;
};

export default WindowWidthState;
